export default __webpack_public_path__ + "static/media/JAC.93e6ea19.png";